import { useState, useCallback, useRef, useEffect } from 'react';

// Este hook fue creado para utilizar cuando hacemos una llamada asincrona y no es necesario el uso del store
// Wrappea la función que recibe para poder ver en que estado se encuentra

// A tener en cuenta: a la hora de usarlo recomiendo fervientemente que a la función que envian la envuelvan en un useCallback, al mismo tiempo es una buena practica
// Para evitar errores como "Maximum update depth exceeded"
// @example src\features\car-data-catalogo\PricesUpdatingModal\PricesUpdatingModal.container.js
const useAsyncFunc = func => {
  const isUnmounted = useRef(false);
  const [state, setState] = useState({ running: false, error: null});
  const setChangingState = newState => {
      if(!isUnmounted.current){
        setState(newState);
      }
    }
  const WrappedFunc = useCallback(
    async (...args) => {
      let result;
      try {
        setChangingState({ ...state, running: true });
        result = await func(...args);
        setChangingState({...state, running: false, error: null})
      } catch(error) {
        setChangingState({...state, error, running: false});
      }
      return result;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [func, setChangingState]
  )
  
  const clear = () => {
    setState({ running: false, error:  null})
  };

  useEffect(() => {
    return () => {
      isUnmounted.current = true;
    };
  }, [])


  return [WrappedFunc, state.error, state.running, clear]
}

export default useAsyncFunc;